angular.module('KhBase').factory("FieldListFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/khutils/fields/');
}]);
